import classNames from 'classnames';
import { useId, type FC, type SVGProps } from 'react';

export const CarOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      fill="none"
      {...props}
    >
      <g id="car">
        <path
          id="Vector"
          d="M19.511 18.4688H6.48991C5.91461 18.4688 5.44824 18.0025 5.44824 17.4272V13.7813C5.44824 12.6307 6.38098 11.698 7.53157 11.698H18.4693C19.6199 11.698 20.5527 12.6307 20.5527 13.7813V17.4272C20.5527 18.0025 20.0863 18.4688 19.511 18.4688Z"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.35417 15.0833C9.35417 15.371 9.12098 15.6042 8.83333 15.6042C8.54568 15.6042 8.3125 15.371 8.3125 15.0833C8.3125 14.7957 8.54568 14.5625 8.83333 14.5625C9.12098 14.5625 9.35417 14.7957 9.35417 15.0833Z"
          stroke="currentColor"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M17.6872 15.0833C17.6872 15.371 17.454 15.6042 17.1663 15.6042C16.8787 15.6042 16.6455 15.371 16.6455 15.0833C16.6455 14.7957 16.8787 14.5625 17.1663 14.5625C17.454 14.5625 17.6872 14.7957 17.6872 15.0833Z"
          stroke="currentColor"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M19.5103 11.698H6.48926L7.24079 7.18883C7.40821 6.18428 8.27736 5.448 9.29577 5.448H16.7038C17.7222 5.448 18.5914 6.18428 18.7588 7.18883L19.5103 11.698Z"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M7.53125 18.9895V20.552"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M18.4688 18.9895V20.552"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const DocumentAddOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M11.25 19.75H7.75C6.64543 19.75 5.75 18.8546 5.75 17.75V7.25C5.75 6.14543 6.64543 5.25 7.75 5.25H14L18.25 9.5V11.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17 15.25V19.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 17.5H14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 9.75H13.75V5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailSentOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 19.75L12 5.25L19.25 19.75L12 16.25L4.75 19.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16V13.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailOpenOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 9.25L12 5.25L19.25 9.25V17.75C19.25 18.8546 18.3546 19.75 17.25 19.75H6.75C5.64543 19.75 4.75 18.8546 4.75 17.75V9.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 9.5L13.25 13.75H10.75L5 9.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailInboxOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.25 11.75L17.6644 6.20056C17.4191 5.34195 16.6344 4.75 15.7414 4.75H8.2586C7.36564 4.75 6.58087 5.34196 6.33555 6.20056L4.75 11.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2142 12.3689C9.95611 12.0327 9.59467 11.75 9.17085 11.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V11.75H14.8291C14.4053 11.75 14.0439 12.0327 13.7858 12.3689C13.3745 12.9046 12.7276 13.25 12 13.25C11.2724 13.25 10.6255 12.9046 10.2142 12.3689Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExclamationIconOutline2: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.95203 16.8535L10.215 6.35653C10.953 4.88476 13.0537 4.88515 13.7911 6.35718L19.0493 16.8542C19.7155 18.1841 18.7485 19.75 17.2611 19.75H6.73989C5.25216 19.75 4.28523 18.1835 4.95203 16.8535Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 10.5V12.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5C11.5 16.2239 11.7239 16 12 16C12.2761 16 12.5 16.2239 12.5 16.5Z"
          stroke="currentColor"
        />
      </g>
    </svg>
  );
};

export const InformationCircleIconOutline2: FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 13V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9C12.5 9.27614 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.72386 12.5 9Z"
        stroke="currentColor"
      />
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockIconOutline2: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M12 8V12L14 14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
};

export const PeppolOnboardingIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  const dropShadowId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 171 78"
      fill="none"
      {...props}
    >
      <defs>
        <filter id={dropShadowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="5" />
          <feOffset dx="0" dy="0" result="offsetblur" />
          <feFlood floodColor="rgba(205,201,211, 0.5)" />
          <feComposite in2="offsetblur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <path
        d="M68.1667 42.3333L69.3176 41.4858C79.2933 34.1393 92.9797 34.4882 102.568 42.3333V42.3333"
        stroke="url(#paint0_linear_8687_3168)"
        strokeWidth="1.66667"
      />
      <path
        d="M68.1667 35.6667L69.3176 36.5142C79.2933 43.8607 92.9797 43.5118 102.568 35.6667V35.6667"
        stroke="url(#paint1_linear_8687_3168)"
        strokeWidth="1.66667"
      />

      <g filter={`url(#${dropShadowId})`}>
        <rect x="6.83334" y="7" width="64" height="64" rx="32" fill="white" />
        <path
          d="M54.8333 39.0007C54.8333 30.1642 47.6699 23.0007 38.8333 23.0007C29.9968 23.0007 22.8333 30.1642 22.8333 39.0007C22.8333 47.8373 29.9968 55.0007 38.8333 55.0007C47.6699 55.0007 54.8333 47.8373 54.8333 39.0007Z"
          fill="white"
        />
        <path
          d="M44.86 46.8307C44.0297 48.0941 42.911 49.0322 41.5038 49.6819C40.0967 50.3315 38.6167 50.6568 37.0649 50.6568C35.3684 50.6568 33.8165 50.3324 32.4813 49.7187C31.146 49.105 29.9913 48.2388 29.0523 47.1919C28.1142 46.1091 27.3918 44.8817 26.8867 43.4745C26.3817 42.0673 26.1292 40.5515 26.1292 38.9628C26.1292 37.3741 26.3817 35.8591 26.9236 34.4511C27.4286 33.0439 28.187 31.7805 29.1251 30.7337C30.0632 29.6868 31.2187 28.8566 32.554 28.2437C33.8893 27.63 35.4052 27.3416 37.0289 27.3416C38.6527 27.3416 40.1326 27.6659 41.4319 28.3524C42.7313 29.0381 43.7422 29.9043 44.5356 30.9511H44.6435V27.8834H50.1292V50.1159H44.9678V46.8675H44.86V46.8316V46.8307ZM31.6142 38.9628C31.6142 39.9009 31.7588 40.8031 32.0473 41.7061C32.3357 42.5724 32.7688 43.3299 33.3107 43.9795C33.8884 44.6292 34.574 45.1701 35.4043 45.5314C36.2346 45.9285 37.1727 46.1091 38.2195 46.1091C39.2664 46.1091 40.1326 45.9285 40.9629 45.5314C41.7932 45.1342 42.4788 44.6292 43.0925 43.9795C43.6703 43.3299 44.1393 42.5724 44.4637 41.7061C44.7881 40.8399 44.9328 39.9018 44.9328 38.9269C44.9328 37.9519 44.7881 37.0866 44.4637 36.1835C44.1393 35.3173 43.6694 34.5598 43.0925 33.9101C42.5147 33.2605 41.7932 32.7195 40.9629 32.3583C40.1326 31.9611 39.2304 31.7805 38.2195 31.7805C37.1368 31.7805 36.1987 31.9611 35.4043 32.3583C34.574 32.7554 33.8884 33.2605 33.3107 33.9101C32.7329 34.5598 32.3366 35.3173 32.0473 36.1835C31.7588 37.1216 31.6142 38.0238 31.6142 38.9628Z"
          fill="#8059C8"
        />
      </g>

      <g filter={`url(#${dropShadowId})`}>
        <rect x="100.167" y="7" width="64" height="64" rx="32" fill="white" />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M148.112 34.0771C147.806 32.8607 146.329 32.2083 143.609 32.088C142.527 30.3379 141.05 28.8655 139.297 27.7887C137.543 26.7119 135.562 26.0606 133.512 25.8868C132.458 23.5838 131.357 22.5282 130.165 22.6748C128.84 22.8346 128.066 24.467 127.651 26.741C125.704 27.4929 123.967 28.7028 122.586 30.2684C120.161 29.5732 118.651 29.723 117.982 30.7242C117.261 31.8054 117.83 33.4132 119.715 35.62C119.491 36.4621 119.352 37.3246 119.302 38.1945C116.923 39.6038 115.912 40.8875 116.221 42.1135C116.534 43.3562 118.132 43.9222 120.303 44.0746C121.195 46.1914 122.625 48.0381 124.451 49.4314C126.277 50.8246 128.436 51.7159 130.714 52.0169C131.604 53.9943 132.669 55.3391 133.898 55.3391C133.966 55.3391 134.035 55.335 134.103 55.3267C135.296 55.1831 136.11 53.9103 136.586 51.4419C137.99 50.9743 139.304 50.2709 140.471 49.362C141.373 49.6654 142.314 49.8374 143.265 49.8726C144.26 49.8726 144.949 49.5766 145.344 48.9847C145.984 48.025 145.605 46.655 144.189 44.804C145.281 42.6104 145.734 40.1542 145.497 37.7155C147.543 36.4201 148.401 35.2225 148.112 34.0771ZM143.709 36.6762C143.723 36.7421 143.732 36.8078 143.744 36.8736C143.558 36.9769 143.362 37.0828 143.151 37.1917C142.051 37.7526 140.922 38.2553 139.77 38.6977C139.547 38.4978 139.275 38.3617 138.981 38.3037C138.687 38.2457 138.384 38.268 138.102 38.3682C137.82 38.4683 137.57 38.6428 137.379 38.873C137.188 39.1032 137.062 39.3808 137.015 39.6764C135.697 40.1054 134.304 40.5073 132.866 40.8697C132.512 40.9589 132.159 41.0443 131.808 41.1257C131.579 40.6361 131.226 40.2141 130.786 39.9008C130.345 39.5874 129.831 39.3934 129.293 39.3375C129.112 37.8407 128.986 36.3726 128.915 34.967C128.917 34.9658 128.919 34.9649 128.921 34.9637C129.175 34.812 129.384 34.5954 129.526 34.3363C129.669 34.0772 129.74 33.7848 129.732 33.4892C129.725 33.1935 129.638 32.9053 129.482 32.654C129.326 32.4027 129.106 32.1974 128.845 32.0592C128.846 30.8448 128.91 29.6312 129.037 28.4235C129.056 28.2593 129.075 28.1032 129.095 27.9512C129.428 27.8515 129.767 27.7644 130.111 27.6939C130.878 27.5366 131.66 27.4571 132.443 27.4567C135.094 27.4642 137.662 28.385 139.714 30.0643C141.767 31.7435 143.177 34.0786 143.709 36.6762ZM131.824 50.4954C131.764 50.3406 131.703 50.1803 131.641 50.011C131.093 48.4725 130.646 46.9005 130.301 45.3045C130.581 45.1732 130.839 45.0011 131.068 44.7938C133.464 46.3104 135.987 47.6182 138.607 48.7025C137.421 49.4602 136.106 49.993 134.727 50.2743C133.772 50.4696 132.797 50.5439 131.824 50.4954ZM122.066 42.505C121.85 42.5082 121.644 42.5086 121.448 42.5061C121.32 42.1073 121.214 41.702 121.129 41.2919C120.844 39.9004 120.818 38.4681 121.054 37.0673C122.613 38.6074 124.278 40.0374 126.035 41.347C125.929 41.626 125.862 41.919 125.839 42.2168C124.587 42.3801 123.328 42.4763 122.066 42.505ZM128.688 40.9625C128.985 40.9073 129.292 40.9413 129.569 41.0602C129.847 41.1792 130.083 41.3777 130.247 41.6308C130.412 41.8839 130.498 42.18 130.494 42.4819C130.49 42.7838 130.397 43.0778 130.226 43.3267C130.056 43.5757 129.815 43.7684 129.535 43.8805C129.254 43.9926 128.947 44.0191 128.652 43.9565C128.356 43.894 128.086 43.7453 127.875 43.5292C127.664 43.3131 127.522 43.0394 127.467 42.7426C127.429 42.5454 127.431 42.3428 127.472 42.1463C127.513 41.9499 127.593 41.7635 127.707 41.598C127.82 41.4325 127.965 41.2911 128.134 41.1821C128.302 41.073 128.491 40.9984 128.688 40.9625ZM130.359 24.2788C130.361 24.2785 130.364 24.2783 130.368 24.2783C130.499 24.2783 131.003 24.5613 131.7 25.8625C131.057 25.8991 130.418 25.9821 129.788 26.1111C129.662 26.1367 129.539 26.1676 129.415 26.1966C129.788 24.7025 130.225 24.2949 130.359 24.2788ZM127.4 28.6063C127.296 29.7069 127.249 30.8871 127.245 32.0809C127.234 32.0871 127.223 32.0919 127.212 32.0984C126.956 32.2515 126.746 32.4704 126.604 32.7323C126.461 32.9942 126.391 33.2896 126.402 33.5876C126.412 33.8856 126.502 34.1754 126.663 34.4267C126.823 34.6781 127.048 34.8818 127.314 35.0166C127.393 36.6694 127.533 38.2392 127.689 39.5369C127.692 39.5551 127.694 39.5746 127.696 39.5929C127.438 39.7065 127.196 39.8546 126.978 40.0332C125.062 38.6143 123.268 37.0383 121.614 35.3216C121.582 35.2872 121.555 35.2559 121.523 35.2221C121.841 34.309 122.271 33.4391 122.804 32.6327C123.943 30.8991 125.532 29.5074 127.4 28.6063ZM119.326 31.6213C119.394 31.5193 119.956 31.2974 121.514 31.6587C121.495 31.6869 121.475 31.7138 121.456 31.7421C121.023 32.3991 120.649 33.0933 120.339 33.8164C119.283 32.4046 119.247 31.7396 119.326 31.6213ZM117.788 41.7186C117.757 41.5968 117.977 41.0196 119.329 40.0899C119.372 40.6022 119.444 41.1116 119.546 41.6155C119.6 41.8803 119.665 42.1411 119.734 42.3999C118.266 42.2155 117.82 41.8467 117.788 41.7186ZM126.068 48.5993C124.37 47.4828 123 45.9347 122.098 44.114C123.445 44.079 124.788 43.9719 126.124 43.7932C126.359 44.2981 126.724 44.7313 127.182 45.0484C127.64 45.3654 128.173 45.555 128.729 45.5976C129.069 47.1745 129.5 48.7306 130.02 50.258C128.61 49.9573 127.27 49.3947 126.068 48.5993ZM133.909 53.7227C133.775 53.7414 133.263 53.4539 132.557 52.1234C133.319 52.1132 134.079 52.0374 134.829 51.8967C134.455 53.3348 134.026 53.7087 133.909 53.7227ZM144 48.0876C143.926 48.1984 143.37 48.3989 141.901 48.07C142.415 47.5312 142.884 46.9498 143.301 46.3322C144.053 47.4463 144.073 47.979 144 48.0876ZM140.125 47.5457C139.987 47.4974 139.85 47.4491 139.704 47.3945C137.429 46.5432 134.731 45.163 131.952 43.4411C132.029 43.2058 132.077 42.9623 132.096 42.7156C132.503 42.6221 132.895 42.5284 133.261 42.4362C134.751 42.0608 136.196 41.6432 137.565 41.196C137.788 41.391 138.058 41.5232 138.349 41.5788C138.639 41.6344 138.939 41.6115 139.218 41.5124C139.497 41.4133 139.744 41.2416 139.934 41.0151C140.124 40.7886 140.251 40.5154 140.3 40.2237C141.525 39.7555 142.725 39.2224 143.893 38.6267C143.907 38.6193 143.92 38.6121 143.934 38.6047C143.987 40.2824 143.674 41.9514 143.016 43.4955C142.358 45.0396 141.371 46.4218 140.125 47.5457ZM145.202 35.9627C145.027 35.2144 144.787 34.4828 144.484 33.7761C146.053 33.9569 146.514 34.3478 146.546 34.4718C146.578 34.5982 146.367 35.1242 145.202 35.9627Z"
          fill="url(#paint2_radial_8687_3168)"
        />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_8687_3168"
          x1="68.5371"
          y1="41.963"
          x2="101.785"
          y2="41.963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9CDEF" />
          <stop offset="1" stopColor="#8059C8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8687_3168"
          x1="68.5371"
          y1="36.037"
          x2="101.785"
          y2="36.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9CDEF" />
          <stop offset="1" stopColor="#8059C8" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_8687_3168"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(132.167 39.0001) scale(16.1702)"
        >
          <stop offset="0.28045" stopColor="#00BAFF" />
          <stop offset="0.97781" stopColor="#007AD7" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const RegenerateIconOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 12.2918L7.29166 14.1668M7.29166 14.1668L9.375 16.0418M7.29166 14.1668H11.0417C13.8031 14.1668 16.0417 11.9283 16.0417 9.16683V8.9585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.7083 5.8335H8.95834C6.19691 5.8335 3.95834 8.07207 3.95834 10.8335V11.0418M12.7083 5.8335L10.625 7.7085M12.7083 5.8335L10.625 3.9585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DoubleChatIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99151 14.5101C12.7865 14.5101 15.233 12.9956 15.233 9.63003C15.233 6.26449 12.7865 4.75 9.99151 4.75C7.19653 4.75 4.75 6.26449 4.75 9.63003C4.75 10.8662 5.08005 11.8526 5.6362 12.606C5.83794 12.8793 5.79543 13.5163 5.63421 13.8153C5.24836 14.5309 5.97738 15.315 6.76977 15.1333C7.3629 14.9974 7.98504 14.8134 8.5295 14.5666C8.72883 14.4762 8.94893 14.4398 9.16641 14.4644C9.43657 14.4949 9.7123 14.5101 9.99151 14.5101Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2272 10.5C18.8553 11.2712 19.2329 12.3078 19.2329 13.63C19.2329 14.8662 18.9029 15.8526 18.3467 16.606C18.145 16.8793 18.1875 17.5163 18.3487 17.8153C18.7346 18.5309 18.0055 19.315 17.2132 19.1333C16.62 18.9974 15.9979 18.8134 15.4534 18.5666C15.2541 18.4762 15.034 18.4398 14.8165 18.4644C14.5464 18.4949 14.2706 18.5101 13.9914 18.5101C12.6956 18.5101 11.4748 18.1846 10.5378 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HeartIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9934 9.64436C14.0607 7.48008 10.8378 6.8979 8.41625 8.87972C5.9947 10.8616 5.65378 14.1751 7.55543 16.519L15.9934 24.3334L24.4314 16.519C26.3331 14.1751 26.0338 10.8407 23.5706 8.87972C21.1074 6.91874 17.9261 7.48008 15.9934 9.64436Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.3333 10.6666C20.3333 13.0598 18.3932 14.9999 16 14.9999C13.6067 14.9999 11.6666 13.0598 11.6666 10.6666C11.6666 8.27335 13.6067 6.33325 16 6.33325C18.3932 6.33325 20.3333 8.27335 20.3333 10.6666Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.12997 25.6667H22.87C24.3925 25.6667 25.5653 24.3576 24.8543 23.0113C23.8084 21.0308 21.4239 18.6667 16 18.6667C10.576 18.6667 8.19152 21.0308 7.14561 23.0113C6.43459 24.3576 7.60741 25.6667 9.12997 25.6667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PeppolColoredIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  const id1 = '_' + useId();
  const id2 = '_' + useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      fill="none"
      {...props}
    >
      <g clipPath={'url(#' + id2 + ')'}>
        <path
          d="M17.9696 7.40035C17.7974 6.7161 16.9663 6.34916 15.4366 6.28146C14.8279 5.29705 13.9971 4.46883 13.0109 3.86313C12.0246 3.25742 10.9102 2.89104 9.75691 2.79333C9.16413 1.49788 8.5446 0.904092 7.87433 0.986537C7.12909 1.07646 6.69346 1.99465 6.4603 3.2738C5.36496 3.69671 4.38765 4.37731 3.6111 5.25798C2.24693 4.86689 1.39772 4.95117 1.02157 5.51435C0.615495 6.12249 0.935794 7.02689 1.99608 8.26823C1.87008 8.74191 1.79217 9.22709 1.76351 9.7164C0.425654 10.5091 -0.143064 11.2312 0.030702 11.9208C0.206846 12.6199 1.10553 12.9382 2.32659 13.0239C2.82835 14.2147 3.63282 15.2534 4.66014 16.0371C5.68745 16.8208 6.90189 17.3222 8.18287 17.4915C8.68369 18.6038 9.28262 19.3602 9.97397 19.3602C10.0125 19.3602 10.051 19.3579 10.0892 19.3533C10.7603 19.2725 11.2183 18.5565 11.4859 17.1681C12.2756 16.905 13.0147 16.5094 13.6716 15.9981C14.1789 16.1688 14.7081 16.2655 15.243 16.2853C15.8028 16.2853 16.1901 16.1188 16.4124 15.7859C16.7727 15.2461 16.5591 14.4754 15.7628 13.4342C16.3769 12.2003 16.6317 10.8187 16.4983 9.44694C17.6495 8.71827 18.132 8.04464 17.9696 7.40035ZM15.4929 8.86237C15.5005 8.89939 15.5058 8.93635 15.5127 8.97337C15.408 9.0315 15.2973 9.09103 15.1788 9.15234C14.5602 9.46784 13.9253 9.75059 13.2769 9.99942C13.1517 9.88698 12.9984 9.81042 12.8332 9.77779C12.6681 9.74517 12.4972 9.7577 12.3386 9.81406C12.18 9.87043 12.0395 9.96853 11.932 10.098C11.8244 10.2276 11.7538 10.3837 11.7276 10.5499C10.9859 10.7913 10.2023 11.0174 9.3934 11.2212C9.19415 11.2714 8.99585 11.3194 8.7985 11.3652C8.66938 11.0898 8.47124 10.8524 8.22331 10.6762C7.97538 10.4999 7.68609 10.3908 7.38352 10.3593C7.28209 9.51736 7.21128 8.69155 7.17096 7.90092C7.1721 7.90022 7.1733 7.89974 7.17448 7.89904C7.31728 7.8137 7.4348 7.69191 7.51499 7.54616C7.59518 7.40041 7.63515 7.23595 7.6308 7.06965C7.62645 6.90335 7.57793 6.7412 7.49022 6.59984C7.40252 6.45849 7.27878 6.34301 7.13171 6.26526C7.13238 5.58216 7.16853 4.89955 7.23999 4.2202C7.25023 4.12786 7.26114 4.04003 7.27239 3.95454C7.45972 3.89847 7.6501 3.84943 7.84402 3.80977C8.27555 3.7213 8.71491 3.67662 9.15541 3.67639C10.6469 3.68058 12.0915 4.19856 13.2458 5.14313C14.4001 6.08771 15.1937 7.40117 15.4929 8.86237ZM8.80747 16.6356C8.77346 16.5486 8.73909 16.4584 8.70429 16.3632C8.39648 15.4978 8.14475 14.6135 7.95065 13.7157C8.10799 13.6419 8.25347 13.5451 8.38234 13.4285C9.73017 14.2816 11.1489 15.0172 12.6228 15.6271C11.9558 16.0533 11.2159 16.353 10.4403 16.5112C9.90342 16.6212 9.35481 16.6629 8.80747 16.6356ZM3.3185 12.141C3.19684 12.1428 3.08097 12.143 2.97087 12.1416C2.89895 11.9173 2.8391 11.6894 2.79156 11.4587C2.63096 10.6759 2.61654 9.87028 2.74902 9.08232C3.62626 9.94866 4.56261 10.753 5.55131 11.4897C5.49123 11.6466 5.45398 11.8114 5.44071 11.9789C4.73671 12.0708 4.02829 12.1249 3.3185 12.141ZM7.04359 11.2734C7.21055 11.2423 7.38296 11.2614 7.53905 11.3284C7.69513 11.3953 7.82787 11.507 7.92048 11.6493C8.01308 11.7916 8.0614 11.9583 8.05931 12.1281C8.05723 12.2979 8.00484 12.4632 7.90877 12.6033C7.81269 12.7433 7.67725 12.8517 7.51957 12.9148C7.3619 12.9778 7.18906 12.9927 7.02292 12.9575C6.85679 12.9224 6.70481 12.8387 6.58621 12.7172C6.46762 12.5956 6.38773 12.4416 6.35665 12.2747C6.33548 12.1638 6.33649 12.0498 6.35962 11.9393C6.38275 11.8288 6.42755 11.724 6.49142 11.6309C6.55529 11.5378 6.63697 11.4582 6.73175 11.3969C6.82652 11.3355 6.93251 11.2936 7.04359 11.2734ZM7.98311 1.88878C7.98463 1.88865 7.98641 1.88853 7.98831 1.88853C8.06204 1.88853 8.34586 2.04772 8.73751 2.77961C8.37609 2.8002 8.01662 2.84694 7.66195 2.91946C7.59155 2.93385 7.52229 2.95125 7.45262 2.96758C7.66214 2.12714 7.90805 1.89785 7.98311 1.88878ZM6.31898 4.32303C6.26022 4.94212 6.23397 5.60599 6.23188 6.27747C6.22573 6.28096 6.21939 6.28369 6.2133 6.28733C6.06935 6.37343 5.95111 6.49656 5.87093 6.64389C5.79074 6.79122 5.75153 6.95736 5.75738 7.12499C5.76323 7.29263 5.81394 7.45563 5.90421 7.59701C5.99448 7.73839 6.12101 7.85297 6.27063 7.92881C6.31525 8.85853 6.39364 9.7415 6.48167 10.4715C6.4829 10.4817 6.48436 10.4927 6.4856 10.503C6.3403 10.5669 6.20435 10.6502 6.08146 10.7507C5.00391 9.9525 3.9947 9.06601 3.06428 8.10036C3.04622 8.08102 3.03088 8.06343 3.01328 8.04441C3.19177 7.53077 3.4338 7.04146 3.73374 6.58789C4.37444 5.61271 5.268 4.82989 6.31898 4.32303ZM1.7775 6.01897C1.81579 5.9616 2.13194 5.83677 3.00806 6.04002C2.99741 6.05587 2.98593 6.07099 2.97541 6.08693C2.73184 6.45648 2.52159 6.84694 2.34716 7.25372C1.75321 6.45957 1.73299 6.08551 1.7775 6.01897ZM0.911894 11.6987C0.894714 11.6302 1.01824 11.3055 1.77873 10.7825C1.803 11.0707 1.8439 11.3573 1.90124 11.6407C1.93167 11.7896 1.96793 11.9363 2.00692 12.0819C1.18126 11.9782 0.93012 11.7707 0.911894 11.6987ZM5.56953 15.5691C4.6146 14.941 3.84392 14.0703 3.33657 13.0461C4.09405 13.0264 4.84994 12.9662 5.60098 12.8657C5.73322 13.1496 5.93863 13.3933 6.19614 13.5717C6.45366 13.75 6.75399 13.8567 7.06632 13.8806C7.2579 14.7677 7.50033 15.6429 7.79242 16.5021C6.99959 16.333 6.24557 16.0165 5.56953 15.5691ZM9.98044 18.451C9.90494 18.4615 9.6168 18.2998 9.21976 17.5514C9.64853 17.5457 10.076 17.503 10.4975 17.4239C10.2874 18.2328 10.0462 18.4431 9.98044 18.451ZM15.6565 15.2813C15.6149 15.3436 15.3021 15.4564 14.4755 15.2714C14.7651 14.9683 15.0287 14.6413 15.2633 14.2938C15.6863 14.9205 15.6973 15.2202 15.6565 15.2813ZM13.4765 14.9765C13.3993 14.9493 13.3223 14.9221 13.2401 14.8914C11.9604 14.4125 10.4424 13.6362 8.87961 12.6676C8.92266 12.5353 8.9498 12.3983 8.96047 12.2595C9.18958 12.2069 9.40969 12.1542 9.61554 12.1024C10.4537 11.8912 11.2667 11.6563 12.037 11.4047C12.1621 11.5144 12.3142 11.5888 12.4776 11.6201C12.641 11.6513 12.8098 11.6384 12.9666 11.5827C13.1234 11.527 13.2624 11.4304 13.3694 11.303C13.4764 11.1755 13.5474 11.0219 13.5752 10.8578C14.2643 10.5944 14.939 10.2946 15.5964 9.95949C15.6044 9.95534 15.6116 9.95128 15.6196 9.94713C15.6492 10.8908 15.4729 11.8296 15.1028 12.6982C14.7327 13.5668 14.1777 14.3442 13.4765 14.9765ZM16.3328 8.46099C16.2342 8.04006 16.099 7.62853 15.9289 7.23106C16.8111 7.33274 17.0708 7.5526 17.0884 7.62236C17.1063 7.69349 16.9879 7.98936 16.3328 8.46099Z"
          fill={'url(#' + id1 + ')'}
        />
      </g>
      <defs>
        <radialGradient
          id={id1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.00017 10.1695) scale(9.09576)"
        >
          <stop offset="0.28045" stopColor="#00BAFF" />
          <stop offset="0.97781" stopColor="#007AD7" />
        </radialGradient>
        <clipPath id={id2}>
          <rect
            width="18"
            height="18.3812"
            fill="white"
            transform="translate(0 0.979004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShieldTickIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12 4.75L4.74999 8C4.74999 8 3.99999 19.25 12 19.25C20 19.25 19.25 8 19.25 8L12 4.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 12.75L11 14.25L14.25 9.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ArrowLeftIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M13.6666 23L6.33329 16L13.6666 9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M6.66663 15.25C6.25241 15.25 5.91663 15.5858 5.91663 16C5.91663 16.4142 6.25241 16.75 6.66663 16.75L6.66663 15.25ZM25.6666 16.75L26.4166 16.75L26.4166 15.25L25.6666 15.25L25.6666 16.75ZM6.66663 16.75L25.6666 16.75L25.6666 15.25L6.66663 15.25L6.66663 16.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CloudIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 14C4.75 15.7949 6.20507 17.25 8 17.25H16C17.7949 17.25 19.25 15.7949 19.25 14C19.25 12.2869 17.9246 10.8834 16.2433 10.759C16.1183 8.5239 14.2663 6.75 12 6.75C9.73368 6.75 7.88168 8.5239 7.75672 10.759C6.07542 10.8834 4.75 12.2869 4.75 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileCheckMarkIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.75 4.75H7.75C6.64543 4.75 5.75 5.64543 5.75 6.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25H11.25M12.75 4.75V8.25C12.75 9.35457 13.6454 10.25 14.75 10.25H18.25M12.75 4.75L18.25 10.25M18.25 10.25V11.25M19.25 14.75C19.25 14.75 17.3214 16.8393 16.3571 19.25L14.75 17.3214"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12 11.0005L12 9.00049"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 15.0005C11.5 14.7243 11.7239 14.5005 12 14.5005C12.2761 14.5005 12.5 14.7243 12.5 15.0005C12.5 15.2766 12.2761 15.5005 12 15.5005C11.7239 15.5005 11.5 15.2766 11.5 15.0005Z"
          stroke="currentColor"
        />
        <path
          d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const UsersIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M5.78164 19.25H13.2183C13.7828 19.25 14.227 18.7817 14.1145 18.2285C13.8039 16.7012 12.7896 14 9.49996 14C6.21027 14 5.19601 16.7012 4.88545 18.2285C4.77296 18.7817 5.21714 19.25 5.78164 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 14C17.8288 14 18.6802 16.1479 19.0239 17.696C19.2095 18.532 18.5333 19.25 17.6769 19.25H16.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 7.5C12.25 9.01878 11.0188 10.25 9.5 10.25C7.98122 10.25 6.75 9.01878 6.75 7.5C6.75 5.98122 7.98122 4.75 9.5 4.75C11.0188 4.75 12.25 5.98122 12.25 7.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 10.25C16.2688 10.25 17.25 9.01878 17.25 7.5C17.25 5.98122 16.2688 4.75 14.75 4.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ChecklistIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 6.50758C4.75 5.53689 5.53689 4.75 6.50758 4.75H17.4924C18.4631 4.75 19.25 5.53689 19.25 6.50758V17.4924C19.25 18.4631 18.4631 19.25 17.4924 19.25H6.50758C5.53689 19.25 4.75 18.4631 4.75 17.4924V6.50758Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7888 9.56348H15.9858"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M13.7379 15.0361H15.9349"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M8 9.53984L8.9 10.4398L11 8.33984"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.74L8.9 15.64L11 13.54"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const AtSymbolIconOutLine: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M5.404 14.596A6.5 6.5 0 1 1 16.5 10a1.25 1.25 0 0 1-2.5 0 4 4 0 1 0-.571 2.06A2.75 2.75 0 0 0 18 10a8 8 0 1 0-2.343 5.657.75.75 0 0 0-1.06-1.06 6.5 6.5 0 0 1-9.193 0ZM10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const KeyIconSolidMiniIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M8 7a5 5 0 1 1 3.61 4.804l-1.903 1.903A1 1 0 0 1 9 14H8v1a1 1 0 0 1-1 1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L8.196 8.39A5.002 5.002 0 0 1 8 7Zm5-3a.75.75 0 0 0 0 1.5A1.5 1.5 0 0 1 14.5 7 .75.75 0 0 0 16 7a3 3 0 0 0-3-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const InfoIconOutline = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M10 10.8333V12.5"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M10.4167 7.49998C10.4167 7.7301 10.2301 7.91665 10 7.91665C9.76989 7.91665 9.58334 7.7301 9.58334 7.49998C9.58334 7.26986 9.76989 7.08331 10 7.08331C10.2301 7.08331 10.4167 7.26986 10.4167 7.49998Z"
          stroke="currentColor"
          strokeWidth="0.833333"
        />
        <path
          d="M16.0417 9.99998C16.0417 13.3367 13.3367 16.0416 10 16.0416C6.66329 16.0416 3.95834 13.3367 3.95834 9.99998C3.95834 6.66326 6.66329 3.95831 10 3.95831C13.3367 3.95831 16.0417 6.66326 16.0417 9.99998Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 8.75C4.75 7.64543 5.64543 6.75 6.75 6.75H17.25C18.3546 6.75 19.25 7.64543 19.25 8.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V8.75Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.75V8.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16 4.75V8.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 10.75H16.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const XIconIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M17.25 6.75L6.75 17.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 6.75L17.25 17.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RetryIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={classNames('rotate-180', props.className)}
    >
      <path
        d="M6.87348 17.1265L7.40381 16.5962L6.87348 17.1265ZM17.1265 17.1265L16.5962 16.5962V16.5962L17.1265 17.1265ZM16.5962 7.40381L17.1265 7.93414L18.1872 6.87348L17.6569 6.34315L16.5962 7.40381ZM6.87348 6.87348L7.40381 7.40381H7.40381L6.87348 6.87348ZM19.2851 15.3103C19.4564 14.9332 19.2896 14.4886 18.9125 14.3173C18.5353 14.146 18.0907 14.3128 17.9194 14.69L19.2851 15.3103ZM6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569L16.5962 16.5962C14.0578 19.1346 9.94221 19.1346 7.40381 16.5962L6.34315 17.6569ZM17.6569 6.34315C14.5327 3.21895 9.46734 3.21895 6.34315 6.34315L7.40381 7.40381C9.94221 4.8654 14.0578 4.8654 16.5962 7.40381L17.6569 6.34315ZM6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569L7.40381 16.5962C4.8654 14.0578 4.8654 9.94221 7.40381 7.40381L6.34315 6.34315ZM17.6569 17.6569C18.3553 16.9584 18.8985 16.1616 19.2851 15.3103L17.9194 14.69C17.606 15.3799 17.1654 16.027 16.5962 16.5962L17.6569 17.6569Z"
        fill="currentColor"
      />
      <path
        d="M19.25 19.25V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75H14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachmentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7 11V14.6C7 17.2509 9.14903 19.4 11.8 19.4H12.2C14.851 19.4 17 17.2509 17 14.6V7.99998C17 6.12221 15.4778 4.59998 13.6 4.59998C11.7222 4.59998 10.2 6.12221 10.2 7.99998V14.3C10.2 15.2389 10.9611 16 11.9 16C12.8389 16 13.6 15.2389 13.6 14.3V8.59998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.62117 14.9627L6.72197 15.1351C7.53458 15.2623 8.11491 16.0066 8.05506 16.8451L7.97396 17.9816C7.95034 18.3127 8.12672 18.6244 8.41885 18.7686L9.23303 19.1697C9.52516 19.3139 9.87399 19.2599 10.1126 19.0352L10.9307 18.262C11.5339 17.6917 12.4646 17.6917 13.0685 18.262L13.8866 19.0352C14.1252 19.2608 14.4733 19.3139 14.7662 19.1697L15.5819 18.7678C15.8733 18.6244 16.0489 18.3135 16.0253 17.9833L15.9441 16.8451C15.8843 16.0066 16.4646 15.2623 17.2772 15.1351L18.378 14.9627C18.6985 14.9128 18.9568 14.6671 19.0292 14.3433L19.23 13.4428C19.3025 13.119 19.1741 12.7831 18.9064 12.5962L17.9875 11.9526C17.3095 11.4774 17.1024 10.5495 17.5119 9.82051L18.067 8.83299C18.2284 8.54543 18.2017 8.18538 17.9993 7.92602L17.4363 7.2035C17.2339 6.94413 16.8969 6.83701 16.5867 6.93447L15.5221 7.26794C14.7355 7.51441 13.8969 7.1012 13.5945 6.31908L13.1866 5.26148C13.0669 4.95218 12.7748 4.7492 12.4496 4.75L11.5472 4.75242C11.222 4.75322 10.9307 4.95782 10.8126 5.26793L10.4149 6.31344C10.1157 7.1004 9.27319 7.51683 8.4842 7.26874L7.37553 6.92078C7.0645 6.82251 6.72591 6.93044 6.52355 7.19142L5.96448 7.91474C5.76212 8.17652 5.73771 8.53738 5.90228 8.82493L6.47 9.81487C6.88812 10.5446 6.68339 11.4814 6.00149 11.9591L5.0936 12.5954C4.82588 12.7831 4.69754 13.119 4.76998 13.442L4.97077 14.3425C5.04242 14.6671 5.30069 14.9128 5.62117 14.9627Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5911 10.4089C14.4696 11.2875 14.4696 12.7125 13.5911 13.5911C12.7125 14.4696 11.2875 14.4696 10.4089 13.5911C9.53036 12.7125 9.53036 11.2875 10.4089 10.4089C11.2875 9.53036 12.7125 9.53036 13.5911 10.4089Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const QuestionMarkCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <circle
          cx="12"
          cy="12"
          r="7.25"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M10.7109 8.97649C11.5018 8.28453 12.7839 8.28453 13.5748 8.97649C14.3656 9.66845 14.3656 10.7903 13.5748 11.4823C13.4371 11.6027 13.2846 11.7022 13.1224 11.7807C12.619 12.0243 12.1429 12.4546 12.1429 13.0138V13.52M12.1427 15.545H12.1478V15.5501H12.1427V15.545Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailSendOutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M16.75 19.5005L19.25 17.2505M19.25 17.2505L16.75 15.0005M19.25 17.2505H13.85"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 11.3005V6.75049C19.25 5.64592 18.3546 4.75049 17.25 4.75049H6.75C5.64543 4.75049 4.75 5.64592 4.75 6.75049V15.2505C4.75 16.3551 5.64543 17.2505 6.75 17.2505H10.3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5.50049L12 11.2505L18.5 5.50049"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Send2OutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6.79811 11.9999H9.60612M6.79811 11.9999L4.53591 5.21337C4.41421 4.84825 4.7947 4.51825 5.13894 4.69037L18.9853 11.6135C19.3038 11.7727 19.3038 12.2271 18.9853 12.3863L5.13894 19.3095C4.7947 19.4816 4.41421 19.1516 4.53591 18.7865L6.79811 11.9999Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FloppyDiskIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.75 19V15.75C8.75 15.1977 9.19772 14.75 9.75 14.75H14.25C14.8023 14.75 15.25 15.1977 15.25 15.75V19M8.75 5V8.25M17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H14.1716C14.702 4.75 15.2107 4.96071 15.5858 5.33579L18.6642 8.41421C19.0393 8.78929 19.25 9.29799 19.25 9.82843V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileEuroOutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2 2 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13.75 4.74991L18.25 9.24991H13.75V4.74991ZM13.75 4.74991H7.75C6.64543 4.74991 5.75 5.64534 5.75 6.74991V17.2499C5.75 18.3545 6.64543 19.2499 7.75 19.2499H12.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7404 16.2209H15.7024M18.203 14.1089C17.7888 13.5653 17.2156 13.2289 16.5824 13.2289C15.3188 13.2289 14.2944 14.5685 14.2944 16.2209C14.2944 17.8733 15.3188 19.2128 16.5824 19.2128C17.2156 19.2128 17.7888 18.8764 18.203 18.3329"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.79968 10.8891H9.79968"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.79968 13.7875H10.7997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileMissingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12.75 4.75L17.25 9.25H13.75C13.1977 9.25 12.75 8.80228 12.75 8.25V4.75ZM12.75 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79968 10.7891H9.19968"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79968 13.6875H10.7997"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3717 13.3596C15.016 12.7957 16.0607 12.7957 16.7051 13.3596C17.3494 13.9234 17.3494 14.8376 16.7051 15.4014C16.5929 15.4996 16.4686 15.5806 16.3365 15.6446C15.9263 15.8431 15.5384 16.1937 15.5384 16.6493V17.0618M15.5383 19.2119H15.5424V19.216H15.5383V19.2119Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const BelgiumFlagIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M11.0689 2.24816C10.3467 1.98019 9.56557 1.8335 8.7501 1.8335C7.93464 1.8335 7.15349 1.98019 6.43128 2.24816L5.85156 8.50016L6.43128 14.7522C7.15349 15.0202 7.93464 15.1668 8.7501 15.1668C9.56557 15.1668 10.3467 15.0202 11.0689 14.7522L11.6486 8.50016L11.0689 2.24816Z"
          fill="#FFDA44"
        />
        <path
          d="M15.4167 8.50003C15.4167 5.63362 13.6075 3.18997 11.0688 2.24805V14.7521C13.6075 13.8101 15.4167 11.3665 15.4167 8.50003Z"
          fill="#D80027"
        />
        <path
          d="M2.0835 8.50003C2.0835 11.3665 3.89266 13.8101 6.43133 14.7521V2.24805C3.89266 3.18997 2.0835 5.63362 2.0835 8.50003Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export const GermanyFlagIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M2.62207 15.4782C4.035 19.2862 7.70043 22 12.0001 22C16.2997 22 19.9652 19.2862 21.3781 15.4782L12.0001 14.6087L2.62207 15.4782Z"
          fill="#FFDA44"
        />
        <path
          d="M12.0001 2C7.70043 2 4.035 4.71375 2.62207 8.52176L12.0001 9.39129L21.3781 8.52172C19.9652 4.71375 16.2997 2 12.0001 2Z"
          fill="black"
        />
        <path
          d="M2.62199 8.52173C2.22004 9.60505 2 10.7768 2 12C2 13.2232 2.22004 14.3949 2.62199 15.4782H21.378C21.78 14.3949 22 13.2232 22 12C22 10.7768 21.78 9.60505 21.378 8.52173H2.62199Z"
          fill="#D80027"
        />
      </g>
    </svg>
  );
};

export const GlobeIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = `_${useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
          stroke="#291547"
          strokeWidth="1.379"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.483 12c0 6.207-2.769 10-4.483 10-1.714 0-4.483-3.793-4.483-10S10.287 2 12 2c1.714 0 4.483 3.793 4.483 10ZM2.345 12h19.31"
          stroke="#291547"
          strokeWidth="1.379"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.742 11.987c0 .483-.032.959-.094 1.425-.697 5.266-5.204 9.33-10.662 9.33-2.092 0-4.045-.598-5.697-1.631a10.778 10.778 0 0 1-4.694-6.34 10.772 10.772 0 0 1-.364-2.784c0-5.614 4.3-10.223 9.786-10.713.32-.028.643-.043.97-.043 5.94 0 10.755 4.815 10.755 10.756Z"
          fill="#2563EB"
        />
        <path
          d="M7.229 3.695c-.107.07-.241.078-.363.115-.121.037-.248.128-.248.255 0 .096.076.179.164.217.088.039.187.041.284.043l.501.01A.534.534 0 0 0 7.82 4.3c.163-.082.196-.297.21-.48a1.615 1.615 0 0 0-.017-.495c-.056-.226-.255-.48-.458-.257-.163.178-.097.476-.326.627ZM15.203 19.765c-.027.02-.056.04-.073.07-.031.053-.013.122.018.176.139.248.475.297.757.268a.6.6 0 0 0 .229-.06.606.606 0 0 0 .181-.177 3.008 3.008 0 0 0 .594-1.798c0-.042-.004-.09-.036-.116-.034-.027-.083-.02-.125-.007-.368.109-.575.357-.736.679-.192.381-.46.715-.809.965ZM6.289 21.11a10.778 10.778 0 0 1-4.694-6.339c1.105.533 1.578 1.448 2.73 1.868.581.211 1.2.431 1.583.916.412.522.46 1.26.286 1.9-.173.642.457 1.097.095 1.655Z"
          fill="#34D399"
        />
        <path
          d="M11.986 1.231c-.326 0-.65.015-.97.043-.362.384-1.287.533-1.594 1.185-.048.103-.099.212-.092.326.01.155.128.288.268.355.14.068.3.082.455.087.119.004.24.003.356-.02.185-.038.266-.19.395-.329.089-.174.33-.612.454-.764.289-.353 1.055-.37.8.106-.285.533-.484.674-.578 1.09-.055.245-.117.503-.285.69-.188.212-.725-.022-1.292.079-.567.101-1.193-.233-1.193.257.032.786.1.79-.28 1.247-.379.458-1.076.127-1.44.309-.168.084-.073.739-.121.92-.047.175.041.365.181.48.14.113.323.162.502.182.437.049.89-.058 1.258-.297.241-.156.447-.367.706-.492.258-.126.9-.217 1.097-.01.22.231.136 1.04.444 1.12.245.062.238-.466.365-.685.126-.219.298-.477.55-.46.119.008.223.079.313.155.284.238.166.953.537.938.2-.008.55-.294.805-.556-.7.173.187.8.415.876.23.077.996-.16 1.152.025a.354.354 0 0 1 .093.175c.018.141-.11.256-.233.328-.458.264-.79.63-1.267.858-1.987.95-2.717-1.213-5.83-1.312-.98.207-.806.611-1.35 1.024-.37.28-.495.52-.701.934-.351.701-.111 1.553.24 2.255.243.482.555.96 1.03 1.218.251.137.534.204.813.27l1.26.297c.18.042.364.087.507.203.148.12.231.303.309.478.166.376.334.755.429 1.156.08.337.107.685.205 1.017.202.682.69 2.055.91 2.732.055.167.093.343.18.496.107.185.28.327.478.409.375.155.814.09 1.18-.088.365-.177.671-1.262.965-1.543.89-.854 1.757-1.842 1.973-3.057.052-.296.07-.613.243-.86.17-.242.457-.368.696-.542.296-.215.53-.516.663-.857.067-.171.11-.363.059-.54-.116-.401-.607-.525-.974-.724-1.528-1.072 1.704-.624 2.437-1.028.174-.096.351-.194.49-.337.062-.064.119-.145.114-.235-.002-.057-.072-.766-.099-.817-.128-1.247 1.264-1.247 1.537 1.345.035.471.195.945.518 1.29.323.345.118.886.578.779.063-.466.095-.942.095-1.425 0-5.94-4.815-10.756-10.756-10.756Zm2.764 6.066c-.273-.014-.878-.232-1.123-.11.122-.125.223-.245.276-.325.162-.25.3-.531.55-.695.292-.192.68-.176 1.008-.059.233.084.47.243.516.487.051.269-.163.53-.417.632-.254.101-.537.083-.81.07Z"
          fill="#34D399"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const XMLIcon: FC<{ className?: string }> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992 1.274-2.007Zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999h.706Zm4.71-.674h1.696v.674H8.4V11.85h.791v3.325Z"
      />
    </svg>
  );
};

export const FileTextIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="file-text">
        <path
          id="Vector"
          d="M18 9.25H13.75V5M9.75 15.25H14.25M9.75 12.25H14.25M16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V6.75C5.75 5.64543 6.64543 4.75 7.75 4.75H14L18.25 9V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const SendOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 19.25L12 4.75L19.25 19.25L12 15.75L4.75 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.5V12.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const Sparkles2Icon = (
  props: SVGProps<SVGSVGElement> & { overrideClassName?: string },
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={
        props.overrideClassName
          ? props.overrideClassName
          : classNames(props.className, 'text-[#8059C8]')
      }
    >
      <path
        d="M17 4.75C17 5.89705 15.8971 7 14.75 7C15.8971 7 17 8.10295 17 9.25C17 8.10295 18.1029 7 19.25 7C18.1029 7 17 5.89705 17 4.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14.75C17 15.8971 15.8971 17 14.75 17C15.8971 17 17 18.1029 17 19.25C17 18.1029 18.1029 17 19.25 17C18.1029 17 17 15.8971 17 14.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7.75C9 9.91666 6.91666 12 4.75 12C6.91666 12 9 14.0833 9 16.25C9 14.0833 11.0833 12 13.25 12C11.0833 12 9 9.91666 9 7.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RowsOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M5.75 10.7502H18.25C18.8023 10.7502 19.25 10.3025 19.25 9.75025V6.25C19.25 5.69772 18.8023 5.25 18.25 5.25H5.75C5.19772 5.25 4.75 5.69772 4.75 6.25V9.75025C4.75 10.3025 5.19772 10.7502 5.75 10.7502Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 19.7502H18.25C18.8023 19.7502 19.25 19.3025 19.25 18.7502V15.25C19.25 14.6977 18.8023 14.25 18.25 14.25H5.75C5.19772 14.25 4.75 14.6977 4.75 15.25V18.7502C4.75 19.3025 5.19772 19.7502 5.75 19.7502Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TooltipArrowIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 20 10" fill="none" {...props}>
      <path
        d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
        fill="currentColor"
      />
      <path d="M8.99542 1.85876C9.75604 1.17425 10.9106 1.17422 11.6713 1.85878L16.5281 6.22989C17.0789 6.72568 17.7938 7.00001 18.5349 7.00001L15.89 7L11.0023 2.60207C10.622 2.2598 10.0447 2.2598 9.66436 2.60207L4.77734 7L2.13171 7.00001C2.87284 7.00001 3.58774 6.72568 4.13861 6.22989L8.99542 1.85876Z" />
      <path d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z" />
    </svg>
  );
};

export const VerificationWizardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 170 173"
      {...props}
    >
      <g filter="url(#a)">
        <path
          d="m80.273 6.691-68.482 30.7 1.812 4.042-1.812-4.043c-3.836 1.72-6.598 5.434-6.7 9.933-.234 10.29.117 39.107 10.072 65.531 4.994 13.257 12.511 26.199 23.857 35.849 11.436 9.727 26.482 15.864 45.98 15.864 19.498 0 34.544-6.137 45.98-15.864 11.346-9.65 18.863-22.592 23.857-35.849 9.955-26.424 10.306-55.24 10.072-65.53-.102-4.5-2.864-8.214-6.7-9.934L89.727 6.691a11.556 11.556 0 0 0-9.454 0Z"
          stroke="#C6B5F4"
          strokeWidth="9.905"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="m82.299 11.21-68.483 30.7c-2.23 1-3.718 3.083-3.773 5.526C9.583 67.658 11.53 159.614 85 159.614s75.417-91.956 74.957-112.178c-.055-2.443-1.544-4.527-3.774-5.526l-68.482-30.7a6.604 6.604 0 0 0-5.402 0Z"
          fill="#F6F3FE"
        />
      </g>
      <path
        d="m69 90.14 8.888 10.667 23.111-32"
        stroke="#7431D2"
        strokeWidth="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="a"
          x=".094"
          y=".728"
          width="169.812"
          height="168.792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="13.815" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.338929 0 0 0 0 0.57946 0 0 0 0.2 0" />
          <feBlend in2="shape" result="effect1_innerShadow_8116_36788" />
        </filter>
        <filter
          id="b"
          x="3.75"
          y="10.633"
          width="162.5"
          height="161.481"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25" />
          <feGaussianBlur stdDeviation="3.125" />
          <feColorMatrix values="0 0 0 0 0.207843 0 0 0 0 0.101961 0 0 0 0 0.301961 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8116_36788"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8116_36788"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const FileSearchIcon2 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.85002 20.2002H6.70002C5.70591 20.2002 4.90002 19.3943 4.90002 18.4002V5.35017C4.90002 4.35606 5.70591 3.55017 6.70002 3.55017H16.15C17.1441 3.55017 17.95 4.35606 17.95 5.35017V10.7502M19.075 20.4252L17.8807 19.1923M17.8807 19.1923C18.4802 18.5831 18.85 17.7473 18.85 16.8252C18.85 14.9612 17.339 13.4502 15.475 13.4502C13.6111 13.4502 12.1 14.9612 12.1 16.8252C12.1 18.6891 13.6111 20.2002 15.475 20.2002C16.4168 20.2002 17.2685 19.8144 17.8807 19.1923ZM8.50002 7.15017H14.35M8.50002 10.7502H11.65"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        id="Vector"
        d="M12.75 4.75L17.25 9.25H13.75C13.1977 9.25 12.75 8.80228 12.75 8.25V4.75ZM12.75 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H9.25M13.6125 14.5C14.105 14.035 14.7692 13.75 15.5 13.75C17.0188 13.75 18.25 14.9812 18.25 16.5C18.25 17.2308 17.965 17.895 17.5 18.3875M13.6125 14.5C13.0814 15.0014 12.75 15.712 12.75 16.5C12.75 18.0188 13.9812 19.25 15.5 19.25C16.288 19.25 16.9986 18.9186 17.5 18.3875M13.6125 14.5L17.5 18.3875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DocumentRejectedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 170 173"
      {...props}
    >
      <g filter="url(#a)">
        <path
          d="m80.273 6.691-68.482 30.7 1.812 4.042-1.812-4.043c-3.836 1.72-6.598 5.434-6.7 9.933-.234 10.29.117 39.107 10.072 65.531 4.994 13.257 12.511 26.199 23.857 35.849 11.436 9.727 26.482 15.864 45.98 15.864 19.498 0 34.544-6.137 45.98-15.864 11.346-9.65 18.863-22.592 23.857-35.849 9.955-26.424 10.306-55.24 10.072-65.53-.102-4.5-2.864-8.214-6.7-9.934L89.727 6.691a11.556 11.556 0 0 0-9.454 0Z"
          stroke="#C6B5F4"
          strokeWidth="9.905"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="m82.299 11.21-68.483 30.7c-2.23 1-3.718 3.083-3.773 5.526C9.583 67.658 11.53 159.614 85 159.614s75.417-91.956 74.957-112.178c-.055-2.443-1.544-4.527-3.774-5.526l-68.482-30.7a6.604 6.604 0 0 0-5.402 0Z"
          fill="#F6F3FE"
        />
      </g>
      <path
        d="m71.111 103.773 27.778-26.6M71.648 76.634l26.703 27.678"
        stroke="#7431D2"
        strokeWidth="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="a"
          x=".094"
          y=".728"
          width="169.812"
          height="168.792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="13.815" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.338929 0 0 0 0 0.57946 0 0 0 0.2 0" />
          <feBlend in2="shape" result="effect1_innerShadow_8188_3661" />
        </filter>
        <filter
          id="b"
          x="3.75"
          y="10.633"
          width="162.5"
          height="161.481"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25" />
          <feGaussianBlur stdDeviation="3.125" />
          <feColorMatrix values="0 0 0 0 0.207843 0 0 0 0 0.101961 0 0 0 0 0.301961 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8188_3661"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8188_3661"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const CheckCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#a)">
        <path
          d="M9.75 12.75 11 14.5l3.25-4.75"
          stroke="#fff"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="a"
          x="8.125"
          y="9.125"
          width="7.75"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation=".5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6068_501"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6068_501"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const AccountablePawLogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14.7429 7.43588C14.3031 6.22856 13.154 5.45508 11.9214 5.45508C10.6889 5.45508 9.53979 6.22856 9.09997 7.43588L4.70107 19.5106C4.67116 19.5927 4.73201 19.6796 4.81946 19.6796H7.66958C7.76642 19.6796 7.85294 19.619 7.88605 19.5281L8.86722 16.8348C8.90033 16.7439 8.98684 16.6834 9.08369 16.6834H14.7592C14.856 16.6834 14.9425 16.7439 14.9756 16.8348L15.9568 19.5281C15.9899 19.619 16.0764 19.6796 16.1733 19.6796H19.0234C19.1108 19.6796 19.1717 19.5927 19.1418 19.5106L14.7429 7.43588ZM10.0755 13.5183L11.7706 8.86538C11.8218 8.72464 12.0211 8.72464 12.0723 8.86538L13.7674 13.5183C13.7973 13.6004 13.7365 13.6873 13.649 13.6873H10.1939C10.1064 13.6873 10.0456 13.6004 10.0755 13.5183Z"
        fill="currentColor"
      />
      <path
        d="M8.8515 0.101873C7.94603 0.443978 7.61916 1.54444 8.06513 2.40285C8.39301 3.03399 8.94842 3.46597 9.42917 3.74232C9.77003 3.93824 10.1 4.12914 10.275 4.2305C10.343 4.26985 10.4282 4.23883 10.455 4.16506C10.5238 3.975 10.6538 3.61686 10.7889 3.24787C11.0081 2.64878 11.1705 1.82816 10.8801 1.03121C10.5817 0.211921 9.67021 -0.207452 8.8515 0.101873Z"
        fill="currentColor"
      />
      <path
        d="M4.18964 4.03124C3.71625 4.8746 4.17374 5.92725 5.06744 6.29836C5.72451 6.5712 6.42775 6.54547 6.97369 6.44844C7.36074 6.37965 7.73622 6.31396 7.93548 6.27925C8.01282 6.26575 8.0582 6.18725 8.03121 6.11358C7.96171 5.9238 7.83087 5.56608 7.69698 5.19681C7.47955 4.59722 7.07605 3.86452 6.34108 3.44056C5.58548 3.00472 4.61767 3.26871 4.18964 4.03124Z"
        fill="currentColor"
      />
      <path
        d="M14.9503 0.0875486C14.0366 -0.231847 13.0782 0.401204 12.8675 1.34519C12.7126 2.03922 12.8602 2.72683 13.0506 3.24726C13.1857 3.61623 13.3157 3.9744 13.3845 4.16444C13.4113 4.2382 13.4965 4.2692 13.5645 4.22987C13.7395 4.12851 14.0695 3.93762 14.4103 3.74169C14.9637 3.42358 15.6161 2.89922 15.9064 2.10226C16.2049 1.28295 15.7765 0.376354 14.9503 0.0875486Z"
        fill="currentColor"
      />
      <path
        d="M19.6321 3.99573C19.1378 3.16446 17.9966 3.03394 17.228 3.62167C16.663 4.05378 16.3337 4.6751 16.1448 5.19599C16.0109 5.56526 15.8801 5.923 15.8106 6.11278C15.7836 6.18645 15.829 6.26495 15.9063 6.27845C16.1056 6.31319 16.4811 6.37888 16.8681 6.44766C17.4966 6.55935 18.3335 6.57657 19.0685 6.15261C19.8241 5.71677 20.0791 4.74736 19.6321 3.99573Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilePlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1 1 22 22"
      fill="none"
      strokeWidth="1.5"
      {...props}
    >
      <path
        d="M11.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V6.75C5.75 5.64543 6.64543 4.75 7.75 4.75H14L18.25 9V11.25M17 14.75V19.25M19.25 17H14.75M18 9.25H13.75V5"
        stroke="currentColor"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PinIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M18.25 11C18.25 15 12 19.25 12 19.25C12 19.25 5.75 15 5.75 11C5.75 7.5 8.68629 4.75 12 4.75C15.3137 4.75 18.25 7.5 18.25 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 11C14.25 12.2426 13.2426 13.25 12 13.25C10.7574 13.25 9.75 12.2426 9.75 11C9.75 9.75736 10.7574 8.75 12 8.75C13.2426 8.75 14.25 9.75736 14.25 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MailboxIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M11.2499 15.25V8C11.2499 6.20507 9.7948 4.75 7.99988 4.75C6.20495 4.75 4.74988 6.20507 4.74988 8V15.25C4.74988 15.8023 5.19759 16.25 5.74988 16.25H10.2499C10.8022 16.25 11.2499 15.8023 11.2499 15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49994 9C8.49994 9.27614 8.27608 9.5 7.99994 9.5C7.7238 9.5 7.49994 9.27614 7.49994 9C7.49994 8.72386 7.7238 8.5 7.99994 8.5C8.27608 8.5 8.49994 8.72386 8.49994 9Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M8.74994 4.75H15.2499C17.4591 4.75 19.2499 6.54086 19.2499 8.75V15.25C19.2499 15.8023 18.8022 16.25 18.2499 16.25H8.74994"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7499 9H16.2499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9999 16.5V15.75H14.4999V16.5H15.9999ZM14.4999 19.25C14.4999 19.6642 14.8357 20 15.2499 20C15.6642 20 15.9999 19.6642 15.9999 19.25H14.4999ZM14.4999 16.5V19.25H15.9999V16.5H14.4999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DataTableIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M2.30017 10.374V7.34158L13.4 7.36296L18.3286 7.34158V10.374V13.8396V16.1052C18.3286 16.7679 17.7913 17.3052 17.1286 17.3052H13.4H3.50017C2.83743 17.3052 2.30017 16.7679 2.30017 16.1052V13.8396V10.374Z"
        fill="#fff"
      />
      <path
        d="M4.03297 3.87613H16.5958C17.5528 3.87613 18.3286 4.65193 18.3286 5.60893V7.34173H14.863H10.3144H2.30017V5.60893C2.30017 4.65193 3.07597 3.87613 4.03297 3.87613Z"
        fill="currentColor"
      />
      <path
        d="M17.8783 14.2898H13.7631C13.7726 15.0296 13.7861 15.6256 13.8002 16.0847C13.8101 16.4089 13.8212 16.665 13.8295 16.8553H16.5961C17.3044 16.8551 17.8783 16.2804 17.8783 15.5721V14.2898ZM2.75037 13.3894H12.8539C12.8517 13.0564 12.85 12.7008 12.85 12.323C12.85 11.7759 12.8535 11.2767 12.8578 10.824H2.75037V13.3894ZM13.8285 7.81131C13.8202 7.99947 13.81 8.25266 13.8002 8.57303C13.789 8.93552 13.7788 9.38438 13.7699 9.92361H17.8783V7.79373L13.8285 7.81131ZM2.75037 9.92361H12.8695C12.8785 9.37343 12.8884 8.91496 12.8998 8.54471C12.9091 8.24288 12.9191 7.9995 12.9271 7.81229L2.75037 7.79178V9.92361ZM2.75037 15.5721C2.75037 16.2804 3.3243 16.8551 4.03259 16.8553H12.9281C12.92 16.6657 12.9092 16.4185 12.8998 16.1121C12.8855 15.6451 12.8723 15.04 12.8627 14.2898H2.75037V15.5721ZM17.8783 5.47147C17.8782 4.8037 17.3702 4.26899 16.7191 4.2449C15.4728 4.1988 13.4178 4.15018 10.3148 4.15018C7.21158 4.15018 5.15588 4.1988 3.90955 4.2449C3.25847 4.269 2.75043 4.80371 2.75037 5.47147V6.89139L13.3978 6.9119L17.8783 6.89334V5.47147ZM13.7543 13.3894H17.8783V10.824H13.7582C13.7539 11.276 13.7504 11.7752 13.7504 12.323C13.7504 12.7011 13.7521 13.0567 13.7543 13.3894ZM18.7787 15.5721C18.7787 16.7775 17.8015 17.7555 16.5961 17.7556H4.03259C2.82724 17.7554 1.84998 16.7775 1.84998 15.5721V5.47147C1.85004 4.33593 2.72532 3.38807 3.87634 3.34549C5.13543 3.29892 7.20233 3.24979 10.3148 3.24979C13.427 3.24979 15.4933 3.29891 16.7523 3.34549C17.9033 3.38807 18.7786 4.33593 18.7787 5.47147V15.5721Z"
        fill="#1B1B1B"
      />
      <path
        d="M5.60022 13.3755V10.3431L16.7 10.3645L21.6286 10.3431V13.3755V16.8411V19.1067C21.6286 19.7695 21.0914 20.3067 20.4286 20.3067H16.7H6.80022C6.13748 20.3067 5.60022 19.7695 5.60022 19.1067V16.8411V13.3755Z"
        fill="#fff"
      />
      <path
        d="M7.33302 6.87766H19.8958C20.8528 6.87766 21.6286 7.65346 21.6286 8.61046V10.3433H18.163H13.6144H5.60022V8.61046C5.60022 7.65346 6.37602 6.87766 7.33302 6.87766Z"
        fill="currentColor"
      />
      <path
        d="M21.1783 17.2914H17.0631C17.0727 18.0311 17.0862 18.6271 17.1002 19.0863C17.1101 19.4105 17.1212 19.6665 17.1295 19.8568H19.8961C20.6045 19.8566 21.1783 19.2819 21.1783 18.5736V17.2914ZM6.05042 16.391H16.1539C16.1518 16.0579 16.15 15.7024 16.15 15.3246C16.15 14.7774 16.1536 14.2782 16.1578 13.8255H6.05042V16.391ZM17.1285 10.8128C17.1203 11.001 17.1101 11.2542 17.1002 11.5746C17.0891 11.937 17.0789 12.3859 17.0699 12.9251H21.1783V10.7953L17.1285 10.8128ZM6.05042 12.9251H16.1696C16.1786 12.375 16.1884 11.9165 16.1998 11.5462C16.2091 11.2444 16.2191 11.001 16.2272 10.8138L6.05042 10.7933V12.9251ZM6.05042 18.5736C6.05042 19.2819 6.62434 19.8566 7.33264 19.8568H16.2281C16.22 19.6672 16.2092 19.42 16.1998 19.1136C16.1855 18.6466 16.1724 18.0416 16.1627 17.2914H6.05042V18.5736ZM21.1783 8.47299C21.1783 7.80522 20.6702 7.27052 20.0192 7.24643C18.7729 7.20033 16.7178 7.1517 13.6149 7.1517C10.5116 7.15171 8.45593 7.20033 7.20959 7.24643C6.55852 7.27052 6.05048 7.80523 6.05042 8.47299V9.89291L16.6979 9.91342L21.1783 9.89487V8.47299ZM17.0543 16.391H21.1783V13.8255H17.0582C17.0539 14.2776 17.0504 14.7767 17.0504 15.3246C17.0504 15.7027 17.0521 16.0582 17.0543 16.391ZM22.0787 18.5736C22.0787 19.779 21.1015 20.757 19.8961 20.7572H7.33264C6.12729 20.757 5.15002 19.779 5.15002 18.5736V8.47299C5.15009 7.33745 6.02537 6.38959 7.17639 6.34702C8.43548 6.30044 10.5024 6.25132 13.6149 6.25131C16.727 6.25131 18.7933 6.30044 20.0524 6.34702C21.2034 6.3896 22.0787 7.33745 22.0787 8.47299V18.5736Z"
        fill="#1B1B1B"
      />
    </svg>
  );
};

export const PlusCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.75V15.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 12L8.75 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MinusCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 12L8.75 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockClosedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75001 10.5V10.3427C7.75001 8.78147 7.65609 7.04125 8.74648 5.9239C9.3683 5.2867 10.3745 4.75 12 4.75C13.6255 4.75 14.6317 5.2867 15.2536 5.9239C16.3439 7.04125 16.25 8.78147 16.25 10.3427V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
